<astrobin-toggle-button
  [class.readonly]="props.readonly === true"
  [disabled]="props.disabled === true"
  [label]="props.toggleLabel || ''"
  [labelClassName]="props.labelClassName || ''"
  [style]="{ lineHeight: props.lineHeight || 'unset' }"
  [value]="formControl.value"
  (toggle)="onToggle($event)"
></astrobin-toggle-button>
